export default __webpack_public_path__ + "static/media/ss-syain.41184af5.jpg";